<template>
  <b-form-checkbox 
    v-model="checked"
  >
    <slot />
  </b-form-checkbox>
</template>
<script>
import Vue from "vue";
import { VueDataTablesFiltersMixin } from "vue-datatables.net";

export default Vue.extend({
  name: 'DatatablesFilterCheckbox',
  mixins: [VueDataTablesFiltersMixin],
  computed: {
    checked: {
      get() {
        return this.query === "true";
      },
      set(value) {
        this.query = value.toString();
      }
    }
  },
});
</script>
